// Generated by Melange

import * as SimpleIcons__Icon from "./icon.jsx";

const Github = SimpleIcons__Icon;

const Lastdotfm = SimpleIcons__Icon;

const Musicbrainz = SimpleIcons__Icon;

export {
  Github,
  Lastdotfm,
  Musicbrainz,
}
/* No side effect */
